var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLogoWhite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.065,
    height: 46,
    viewBox: "0 0 81.065 46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2736.295 463.233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2659.509-446.507c-5.255,6.3-14.322,17.552-35.1,18.35l-6.88,7.741a41.8,41.8,0,0,0,4.52.247c24.343,0,35.393-18,39.363-25.215,1.433-2.608.219-3.67-1.907-1.123",
    transform: "translate(1.215 2.436)",
    fill: "#fff",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2683.242-454.6a24.18,24.18,0,0,0,4.673,2.6,8.735,8.735,0,0,0,3.871.534s-5.768-5.526-8.018-7.579l-3.153,3.548a4.781,4.781,0,0,1,2.627.9",
    transform: "translate(1.769 0.608)",
    fill: "#fff",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2696.51-430.683a48.76,48.76,0,0,1-12.808-1.7l-5.043,5.673a42.8,42.8,0,0,0,13.33,3.72l6.882-7.742q-1.156.047-2.362.047",
    transform: "translate(0.759 5.006)",
    fill: "#fff",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2699.736-454.46c1.593.582,2.925,1.383,4.278,1.738a7.1,7.1,0,0,0,3.442-.034c1.958-.664,3.446-1.682,4.916-2.19a5.26,5.26,0,0,1,1.817-.319l3.153-3.548c-.3-.27-.533-.482-.687-.61-1.313-1.109-1.864-1.35-3.031-.6-1.312.839-4.57,2.72-6.134,3.626-1.116.651-1.332.6-2.031-.168-.932-1.02-2.231-2.507-3.333-3.844l-5.031,5.662a5.777,5.777,0,0,1,2.64.291",
    transform: "translate(1.184 0.375)",
    fill: "#fff",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2724.636-432.728A48.377,48.377,0,0,0-2714-425.983l5.042-5.672a48.982,48.982,0,0,1-12.1-5.106Z",
    transform: "translate(0.394 4.284)",
    fill: "#fff",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2730.535-443.39l-2.306,2.594a46.539,46.539,0,0,0,8.491,9.159l3.585-4.032a44.464,44.464,0,0,1-9.775-7.72",
    transform: "translate(0.104 3.19)",
    fill: "#fff",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2735.766 -462.733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2698.451-462.173c-.584-.84-1.374-.637-2.216-.035-1.193.854-17.591,12.362-17.591,12.362a5.267,5.267,0,0,0,2.814.3c3.224-.334,6.523-1.994,9.194-3.324a13.451,13.451,0,0,1,4.429-1.509l5.032-5.66c-.674-.815-1.274-1.576-1.665-2.136",
    transform: "translate(2736.386 462.733)",
    fill: "#fff",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2733.7-446.876c-1.269-2.16-2.544-.776-1.883,1.414a21.072,21.072,0,0,0,2.848,5.42l2.306-2.594a24.852,24.852,0,0,1-3.271-4.24",
    transform: "translate(2735.766 465.17)",
    fill: "#fff",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-white.a1fe9ffe.svg";
export { ForwardRef as ReactComponent };